import { faArrowsRotate, faMemoPad } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getMailersHeaderPreview } from 'bundles/connect/helpers/prospect_api';
import type { MailersHeader } from 'bundles/connect/types';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap-5';

type MailersHeaderPreviewProps = {
  initialHeader: MailersHeader;
  edit?: boolean;
  setShow?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function MailersHeaderPreview({ initialHeader, edit, setShow }: MailersHeaderPreviewProps) {
  const [header, setHeader] = useState<MailersHeader>(initialHeader);
  const [loading, setLoading] = useState(false);

  const debouncedRefresh = useCallback(debounce((header) => {
    refreshPreview(header);
  }, 1000), []);

  const refreshPreview = (header: MailersHeader) => {
    setLoading(true);
    getMailersHeaderPreview(
      { html_left: header.htmlLeft, html_right: header.htmlRight }
    ).then((response) => {
      setHeader({ ...response, logoUrl: header.logoUrl });
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    debouncedRefresh(initialHeader);
  }, [initialHeader]);

  const showPreview = header.htmlLeft || header.htmlRight || header.logoUrl;
  return (
    <div className="mt-2">
      {!edit && (
        <div className="d-flex flex-row align-items-center mb-3">
          <strong className="me-3">Preview</strong>
          {loading && <Spinner animation="border" size="sm" variant="secondary"/>}
        </div>
      )}
      {(showPreview || edit) &&
        <div
          className={`${edit ? '' : 'border'} rounded p-2 bg-white d-flex`}
          style={{ border: `${edit ? '2px dashed #1D357E' : ''}` }}
        >
          <div className="me-auto">
            {header.logoUrl && <img src={header.logoUrl} style={{ maxHeight: '200px', maxWidth: '200px' }} />}
            <div dangerouslySetInnerHTML={{ __html: header.htmlLeft }} />
          </div>
          {edit &&
            <Button
              className="me-auto align-self-center"
              variant="primary"
              onClick={() => setShow && setShow(true)}
            >
              <FontAwesomeIcon className="me-2" icon={faMemoPad} />
              Edit letterhead
            </Button>
          }
          <div dangerouslySetInnerHTML={{ __html: header.htmlRight }}></div>
        </div>}
    </div>
  );
}
